require('./bootstrap');
require('./config/web-sockets');
require('./config/alerts');
require('./config/vue-spa');
require('./config/axios-spa');
